import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=1084ec0c&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=1084ec0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1084ec0c",
  null
  
)

export default component.exports